import React, { useEffect, useState } from "react";
import { DasboardTopBar, DashboardWrapper } from "./dashboardPage.styled";
import { IoFilterOutline } from "react-icons/io5";
import Button from "../../components/button";
import StatsBoxOne from "../../components/statsBox/statsBoxOne";
import { subscriptionData } from "./constant/subscriptionData";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import dayjs from "dayjs";
import { SagaActions } from "../../redux/actionTypes";
import SubscriptionTable from "./components/subscriptionTable";
import RenderIf from "../../components/renderIf";
import { getDashboardStatsReq } from "../../api/dashboard/dashboardStatReq";
import { toast } from "react-toastify";
import { DashboardStatsType } from "../../types/paymentTypes";

// const statsData1 = [
//   {
//     label: "Offer Issues",
//     numbers: 362,
//     desc: "",
//     inPercentage: false,
//     inRupees: false,
//   },
//   {
//     label: "Candidates",
//     numbers: 358,
//     desc: "",
//     inPercentage: false,
//     inRupees: false,
//   },
//   {
//     label: "Companies",
//     numbers: 62,
//     desc: "",
//     inPercentage: false,
//     inRupees: false,
//   },
//   {
//     label: "Engagement",
//     numbers: 89,
//     desc: "",
//     inPercentage: true,
//     inRupees: false,
//   },
//   {
//     label: "Cardsets",
//     numbers: 62,
//     desc: "",
//     inPercentage: false,
//     inRupees: false,
//   },
// ];

// const statsData2 = [
//   {
//     label: "Offer Issues",
//     numbers: 83.6,
//     desc: "250/300",
//     inPercentage: true,
//     inRupees: false,
//   },
//   {
//     label: "Candidates",
//     numbers: 17.8,
//     desc: "50/300",
//     inPercentage: true,
//     inRupees: false,
//   },
//   {
//     label: "Companies",
//     numbers: 62,
//     desc: "Dec 2023",
//     inPercentage: false,
//     inRupees: true,
//   },
// ];

export const DashboardPage = () => {
  const Dispatch = useDispatch();
  const { clients } = useSelector((_state: RootState) => _state);
  const _subscriptionList = clients?.data || [];
  const [dashStatsDetails, setdashStatsDetails] =
    useState<DashboardStatsType>();

  const dashboardStatsList = async () => {
    try {
      const res = await getDashboardStatsReq();
      const _dashboardStats = {
        numberOfCandidateOffers: res?.data?.numberOfCandidateOffers,
        numberOfCandidates: res?.data?.numberOfCandidates,
        numberOfCompanies: res?.data?.numberOfCompanies,
        numberofCardsets: res?.data?.numberofCardsets,
        numberOfAcceptedCandidates: res?.data?.joinedCandidatesCount,
        joinersPercentage: res?.data?.joinersPercentage,
        numberOfDeclinedCandidates: res?.data?.dropoutCandidatesCount,
        declinersPercentage: res?.data?.dropoutPercentage,
        currentMonthTransactions: res?.data?.currentMonthTransactions,
      };
      setdashStatsDetails(_dashboardStats);
    } catch (error) {
      // toast.error(error?.errMessage);
    }
  };
  useEffect(() => {
    dashboardStatsList();
    Dispatch({ type: SagaActions.ADD_CLIENTS_LIST });
  }, []);
  return (
    <DashboardWrapper className="p-2">
      <div className="h-100">
        <DasboardTopBar className="px-4 py-2">
          <div className="bar_title">
            <p className="lg-text">
              <b>Performance stats</b>
              <span>(all clients)</span>
            </p>
          </div>
          <div>
            <Button
              outline
              className={"mx-3 px-3"}
              label="Active/All Time"
              borderColor="secondary"
              onClick={() => {}}
            />
          </div>
          <div className="">
            <IoFilterOutline color="#3A93F4" size={25} className="" />
          </div>
          <div className="px-2"></div>
        </DasboardTopBar>

        <div className="d-flex p-3">
          {/* {statsData1.map((item, idx) => (
            <StatsBoxOne
              key={idx}
              label={item.label}
              numbers={item.numbers}
              desc={item.desc}
              inPercentage={item.inPercentage}
              inRupees={item.inRupees}
              className="mx-2"
            />
          ))} */}
          <StatsBoxOne
            label={"Offer Issues"}
            numbers={dashStatsDetails?.numberOfCandidateOffers || 0}
            desc={""}
            inPercentage={false}
            inRupees={false}
            className="mx-2"
          />
          <StatsBoxOne
            label={"Candidates"}
            numbers={dashStatsDetails?.numberOfCandidates || 0}
            desc={""}
            inPercentage={false}
            inRupees={false}
            className="mx-2"
          />
          <StatsBoxOne
            label={"Companies"}
            numbers={dashStatsDetails?.numberOfCompanies || 0}
            desc={""}
            inPercentage={false}
            inRupees={false}
            className="mx-2"
          />
          <StatsBoxOne
            label={"CardSets"}
            numbers={dashStatsDetails?.numberofCardsets || 0}
            desc={""}
            inPercentage={false}
            inRupees={false}
            className="mx-2"
          />
        </div>
        <div className="d-flex p-3">
          {/* {statsData2.map((item, idx) => (
            <StatsBoxOne
              key={idx}
              label={item.label}
              numbers={item.numbers}
              desc={item.desc}
              inPercentage={item.inPercentage}
              inRupees={item.inRupees}
              className="mx-2"
            />
          ))} */}
          <StatsBoxOne
            label={"Joiners"}
            numbers={dashStatsDetails?.joinersPercentage || 0}
            desc={``}
            presentValue={dashStatsDetails?.numberOfAcceptedCandidates}
            totalValue={dashStatsDetails?.numberOfCandidates}
            presentValueLabel="Joiners"
            totalValueLabel="Out of"
            inPercentage={true}
            inRupees={false}
            className="mx-2"
          />
          <StatsBoxOne
            label={"Drop-outs"}
            numbers={dashStatsDetails?.declinersPercentage || 0}
            desc={``}
            presentValue={dashStatsDetails?.numberOfDeclinedCandidates}
            totalValue={dashStatsDetails?.numberOfCandidates}
            presentValueLabel="Drop-outs"
            totalValueLabel="Out of"
            inPercentage={true}
            inRupees={false}
            className="mx-2"
          />
          {dashStatsDetails?.currentMonthTransactions?.map(
            (item: any, idx: any) => (
              <StatsBoxOne
                key={idx}
                label={"Revenue"}
                numbers={item?.totalAmount || 0}
                desc={`${item?.month} ${item?.year}`}
                inPercentage={false}
                inRupees={true}
                className="mx-2"
              />
            )
          )}
        </div>
      </div>
      <div className="w-50 p-3">
        <div className="shadow-block bg-white p-3 m-1 rounded">
          <p className="m-1 md-text">
            <u>Subscription Expiry:</u>
          </p>
          <div className="p-2"></div>
          <RenderIf isShow={_subscriptionList?.length > 0}>
            <SubscriptionTable tableData={_subscriptionList} />
          </RenderIf>
          <RenderIf isShow={_subscriptionList?.length < 1}>
            <div className="w-100 d-flex align-items-center justify-content-center">
              <p className="text-secondary m-3">-: No Data :-</p>
            </div>
          </RenderIf>
        </div>
      </div>
    </DashboardWrapper>
  );
};
